import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from '../main/alert.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!localStorage.getItem("token")) {
      this.router.navigateByUrl('/login');
      return false;
    }

    // Admins reach everything.
    if (localStorage.getItem("isAdmin") == 'true') {
      return true;
    }

    // Legacy access model: role privileges mapped to a set of allowed UI urls.
    if (localStorage.getItem("urls")) {
      var urls: string[] = JSON.parse(localStorage.getItem('urls'));
      for (let url of urls) {
        if (state.url.includes(url)) return true;
      }
    }

    // New access model: the role's per-page CRUD permissions are enforced by the
    // gateway on every API call, so a role governed by it may navigate the UI.
    if (this.hasPagePermissions()) {
      return true;
    }

    this.toastr.warning('Your access is denied for this service. Please Sign In again', "Warning! Unauthorized");
    return false;
  }

  // roles = ROLE_ARRAY;

  /** True when the signed-in role is governed by the per-page permission model. */
  private hasPagePermissions(): boolean {
    try {
      var pagePermissions = JSON.parse(localStorage.getItem('pagePermissions'));
      return Array.isArray(pagePermissions) && pagePermissions.length > 0;
    } catch (e) {
      return false;
    }
  }

  constructor(private authServ: AuthService, private router: Router, private toastr: AlertService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.authServ.userHasAccess(state, next && next.data ? next.data.pageKey : null);


  }
}
